<template>
  <ul class="form-item-list">
    <li><h3>음주를 하십니까?</h3></li>
    <li class="text-center">
      <el-checkbox
        class="round"
        label="예"
        border
        v-model="yes"
        :error="formData.answer.error"
        @change="event => updateChecked(event, 'yes')"
      />
      <el-checkbox
        class="round"
        label="아니오"
        border
        v-model="no"
        :error="formData.answer.error"
        @change="event => updateChecked(event, 'no')"
      />
    </li>
    <li v-if="yes">
      <div class="detail-form">
        <el-row>
          <div class="label">{{ detail['횟수'].label }}</div>
          <el-input
            type="text"
            v-model="detail['횟수'].value"
            :placeholder="detail['횟수'].placeholder"
            @input="changeDetail('횟수')"
          >
            <span slot="suffix">회</span>
          </el-input>
        </el-row>

        <el-row>
          <div class="label">{{ detail['병수'].label }}</div>
          <el-input
            type="text"
            v-model="detail['병수'].value"
            :placeholder="detail['병수'].placeholder"
            @input="changeDetail('병수')"
          >
            <span slot="suffix">병</span>
          </el-input>
        </el-row>
      </div>
    </li>
  </ul>
</template>

<script>
import { Checkbox, Row, Col, Input } from 'element-ui';

export default {
  name: 'Drunk',
  props: ['formData'],
  components: {
    [Checkbox.name]: Checkbox,
    [Row.name]: Row,
    [Col.name]: Col,
    [Input.name]: Input,
  },
  data() {
    return {
      yes: this.formData.answer.value === '예',
      no: this.formData.answer.value === '아니오',
      detail: {
        '횟수': {
          label: "음주회수(1주 기준)",
          placeholder: '예: 2',
          value: "",
          error: "",
          validations: [
            { type: "required", message: "필수항목입니다" }
          ],
        },
        '병수': {
          label: "1회 음주량(소주 기준)",
          placeholder: '예: 2',
          value: "",
          error: "",
          validations: [
            { type: "required", message: "필수항목입니다" }
          ],
        },
      }
    }
  },
  mounted() { 
    this.$emit('update', { type: '횟수', value: '' });
    this.$emit('update', { type: '병수', value: '' });
  },
  methods: {
    updateChecked(event, type) {
      const reverse = type === 'yes' ? 'no' : 'yes';
      this.$data[reverse] = !event;
      this.$emit('update', { type: 'answer', value: type });
    },
    changeDetail(key) {
      this.$emit('update', { type: key, value: this.detail[key].value });
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item-list {
  li {
    &.text-center {
      text-align: center;
    }
    h3 {
      font-size: 18px !important;
    }
    p {
      span.blue {
        color: #174BE6;
      }
    }
    .el-checkbox {
      &.round {
        width: 40%;
        text-align: left;

        .el-checkbox__inner {
          border-radius: 50% !important;
        }
      }
    }
  }
  .detail-form {
    h3 {
      margin-bottom: 2*$unit;
    }
    .el-row {
      margin-bottom: 2*$unit;

      &.my-1 {
        margin-bottom: $unit;
      }
      .mx-0 {
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: $unit;
      }
      .el-input {
        height: 54px;

        & ::-webkit-input-placeholder { text-align:right; }
        & input:-moz-placeholder { text-align:right; }
  
        .el-input__inner {
          height: 54px;
          border-radius: 0;
        }
  
        .el-input__suffix-inner {
          line-height: 54px;
          color: #000;
        }
      }
    }
  }
}
</style>